import type Validator from '../../models/Validator';

const CurrencyValidator: Validator = class {
  static isValid(value) {
    // https://stackoverflow.com/questions/16242449/regex-currency-validation
    const currency = RegExp('(?=.*?\\d)^-?\\$?(([1-9]\\d{0,2}(,\\d{3})*)|\\d+)?(\\.\\d{1,2})?$');
    return (
      currency.test(value.toString().replace(/,/g, '').replace('$', '')) &&
      Number(value.toString().replace(/,/g, '').replace('$', '')) > 0
    );
  }

  static getError(value) {
    if (Number(value.toString().replace(/,/g, '').replace('$', '')) <= 0) {
      return 'Amount should be more than $0';
    }
    return 'Enter a valid amount';
  }
};

export default CurrencyValidator;
